import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Name = styled.h2(
  ({theme}) => css`
    margin: 0%;
    ${theme.typography.labelMediumBold};
    text-decoration: none;
    color: inherit;

    > :first-child {
      margin-right: 4px;
    }

    > svg {
      margin-right: 2px;
      vertical-align: middle;
    }

    > :last-child {
      margin-right: 0;
      vertical-align: middle;
    }
  `
);
